module.exports = __webpack_public_path__ + "zip-lock.png?7b6699651f6973dbc023bc1d30963bba";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/attachment-format/zip-lock.png
// module id = 41
// module chunks = 0